export const SERVER_ERROR = 'serverError';
export const PASSWORD_MISMATCH = 'passwordMismatch';
